// Libs
import React from 'react';
import {
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormControlProps
} from '@chakra-ui/react';
import { FieldErrorsImpl } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';

interface FormItemProps extends FormControlProps {
    name: string;
    label?: string;
    labelComponent?: React.ReactElement;
    errors: FieldErrorsImpl<any>;
    children: React.ReactNode;
}

export function FormItem({
    children,
    name,
    label,
    labelComponent,
    errors,
    ...rest
}: FormItemProps) {
    return (
        <FormControl
            mb="4"
            isInvalid={errors && Boolean(errors[name])}
            {...rest}>
            {label && !labelComponent && (
                <FormLabel htmlFor={name} color="gray.600">
                    {label}
                </FormLabel>
            )}
            {labelComponent && !label && (
                <FormLabel htmlFor={name} color="gray.600">
                    {labelComponent}
                </FormLabel>
            )}
            {children}
            <ErrorMessage
                errors={errors}
                name={name}
                render={({ message }) => (
                    <FormErrorMessage>{message}</FormErrorMessage>
                )}
            />
        </FormControl>
    );
}
